import localeCurrency from 'locale-currency';
import ct from 'countries-and-timezones';

export const getBrowserCountry = (): string | null => {
  const countryCode = getBrowserISOCountry();

  // This is handling the GB/UK switcheroo we do
  return countryCode === 'GB' ? 'UK' : countryCode;
};

export const getLocationCurrency = (location: string | null): string => {
  if (location === null) {
    location = 'GB';
  }

  // Use the correct ISO code
  if (location === 'UK') {
    location = 'GB';
  }

  const currency = localeCurrency.getCurrency(location);
  const knownCurrencies = ['USD', 'GBP', 'EUR'];

  return knownCurrencies.includes(currency) ? currency : knownCurrencies[0];
};

const getBrowserISOCountry = () => {
  const timezone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
  if (!timezone) {
    return null;
  }

  const country = ct.getCountryForTimezone(timezone);

  if (country === null) {
    return null;
  }

  return country.id;
};
